import PropTypes from 'prop-types';
import React from 'react';
import { ID, withCodes } from 'app/blocks/common/codes';

import './affiliation-list-from-orcid.scss';

function AffiliationListFromOrcid({ l, affiliations }) {
    return (
        <div className="affiliations-list-from-orcid">
            {l('ORCID_AFFILIATION_LIST.MESSAGE_CONFIRM_AFFILIATIONS_IMPORT')}

            <div className="affiliations-list-from-orcid__container">
                {affiliations.map(aff => (
                    <div
                        key={aff.affiliationId || aff.institutionName + aff.departmentName + aff.endDate}
                        className="affiliations-list-from-orcid__elem"
                    >
                        <div className="affiliations-list-from-orcid__label">
                            {l('ORCID_AFFILIATION_LIST.LABEL_AFFILIATION_INSTITUTION_NAME')}
                        </div>
                        <div className="affiliations-list-from-orcid__value">{aff.institutionName}</div>
                        {aff.departmentName && (
                            <div>
                                <div className="affiliations-list-from-orcid__label">
                                    {l('ORCID_AFFILIATION_LIST.LABEL_AFFILIATION_DEPARTMENT_NAME')}
                                </div>
                                <div className="affiliations-list-from-orcid__value">{aff.departmentName}</div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

AffiliationListFromOrcid.propTypes = {
    l: PropTypes.func.isRequired,
    affiliations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default withCodes(AffiliationListFromOrcid, ID.ORCID_AFFILIATION_LIST);
